/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export default styled(Box)(({ theme, ownerState }) => {
  const { palette, borders, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode } = ownerState;
  const { borderRadius } = borders;
  const { transparent, gradients, white, background } = palette;
  const { xxl } = boxShadows;
  const { linearGradient } = functions;

  let backgroundValue = darkMode
    ? background.sidenav
    : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the topnav when miniTopnav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: 'translateX(0)',
    transition: transitions.create('transform', {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter
    }),

    [breakpoints.up('xl')]: {
      transform: 'translateX(0)',
      transition: transitions.create(['width', 'background-color'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen
      })
    }
  });

  return {
    boxShadow: xxl,
    border: 'none',
    borderRadius: borderRadius.lg,
    ...drawerOpenStyles()
  };
});
